import script from "./basicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./basicForm.vue?vue&type=script&setup=true&lang=js"

import "./basicForm.vue?vue&type=style&index=0&id=27a84cb8&scoped=true&lang=scss"
import "./basicForm.vue?vue&type=style&index=1&id=27a84cb8&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a84cb8"]])

export default __exports__